import type { Ref } from 'react';
import React from 'react';
import styles from './FileUploadMenuItem.module.scss';
import { MenuItem } from './Menu';

interface FileUploadMenuItemProps {
  accept?: string;
  children: React.ReactNode;
  icon?: string;
  onUpload: (files: File[]) => void;
  disabled?: boolean;
}

const FileUploadMenuItem = React.forwardRef(
  (
    {
      accept,
      children,
      icon,
      onUpload,
      disabled = false,
      ...props
    }: FileUploadMenuItemProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    const outerRef = React.createRef<HTMLDivElement>();

    return (
      <div ref={outerRef}>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/label-has-associated-control */}
        <label
          // We need to delay calling click handler in case the button
          // is in a `PopOver` and a click would result in `PopOver` being closed and
          // `input` being removed before we can read its value.
          onClick={(e) => e.stopPropagation()}
        >
          <MenuItem
            icon={icon}
            ref={ref}
            disabled={disabled}
            {...props}
            id="aria-file-upload-menu-item"
          >
            {!disabled && (
              <input
                aria-labelledby="aria-file-upload-menu-item"
                accept={accept}
                className={styles.input}
                onChange={(e) => {
                  if (e.currentTarget.files == null) return;

                  onUpload(Array.from(e.currentTarget.files));
                  e.currentTarget.value = '';
                  outerRef.current?.click();
                }}
                type="file"
              />
            )}
            {children}
          </MenuItem>
        </label>
      </div>
    );
  },
);

export default FileUploadMenuItem;
